import { useTranslation } from 'react-i18next';
import useClassesPendingSummaryTotal from '@/data/hook/useClassesPendingSummaryTotal';
import { Loading, Stats } from '@/components/ui/daisy';
import { Link } from 'react-router-dom';
import { ROUTES } from '@/utils/routes';
import { PendenciesTabEnum } from '@/pages/pendencies/PendenciesPage';
import { Colors } from '@/components/ui/types';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';

type statsMap = {
  title: string;
  value: number | undefined;
  color: Extract<Colors, 'info' | 'secondary' | 'accent'>;
  link: string;
};

export function PendenciesCount() {
  const { t } = useTranslation('translation', { keyPrefix: 'pendencies' });
  const { pendingCount, isLoading } = useClassesPendingSummaryTotal();
  const stats: statsMap[] = [
    {
      title: t('tabs.attendance'),
      value: pendingCount?.pendingReportsCount,
      color: 'info',
      link: `${ROUTES.PENDENCIES.BASE}?tab=${PendenciesTabEnum.ATTENDANCE}`,
    },
    {
      title: t('tabs.exams'),
      value: pendingCount?.pendingExamsCount,
      color: 'secondary',
      link: `${ROUTES.PENDENCIES.BASE}?tab=${PendenciesTabEnum.EXAMS}`,
    },
    {
      title: t('tabs.activities'),
      value: pendingCount?.pendingActivitiesCount,
      color: 'accent',
      link: `${ROUTES.PENDENCIES.BASE}?tab=${PendenciesTabEnum.ACTIVITIES}`,
    },
  ];

  return (
    <div className="rounded-2xl border border-base-content/10 flex justify-center items-center h-36">
      <ConditionalRenderer
        condition={!isLoading}
        fallback={<Loading className="size-6" />}
      >
        <Stats className="size-full">
          {stats.map(stat => (
            <Stats.Stat key={stat.link}>
              <Link
                to={stat.link}
                className="flex flex-col justify-center items-center"
              >
                <Stats.Title className="font-bold text-base-content/60">
                  {stat.title}
                </Stats.Title>
                <Stats.Value color={stat.color}>{stat.value}</Stats.Value>
                <Stats.Description>{t('outstanding')}</Stats.Description>
              </Link>
            </Stats.Stat>
          ))}
        </Stats>
      </ConditionalRenderer>
    </div>
  );
}
